import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { bindScrollDepth, resetMarks } from './scrollEvents';
import * as React from 'react';

let lastPathName = '';
//todo: this should be a hook, once App.tsx is rewritten to a function component
export function ScrollTracker() {
  const history = useHistory();
  useEffect(() => {
    bindScrollDepth();
    history.listen((location, action) => {
      //changing hash should not reset scrolling:
      if (location.pathname !== lastPathName) {
        //we want to skip scroll to top:
        window.setTimeout(resetMarks, 500);
        lastPathName = location.pathname;
      }
    });
  }, []);
  return <></>;
}
